module.exports = "/_next/static/images/handshake-min-7702a49078f399d06788dce323828fa2.jpg";